export const jwtTokenStorageKey = 'auth/jwtToken';

export const levelUpStorageKey = 'auth/levelUp';

export const languageStorageKey = 'locale/language';

export const musicStorageKey = 'appSettings/musicOn';

export const soundStorageKey = 'appSettings/soundOn';

export const gameInProgressStorageKey = 'game/gameInProgress';

export const registerMsisdnStorageKey = 'register/registerMsisdn';
